const SECONDARY_REFERENCE_KEYS = ["catalogId", "dealId"];

/**
 * Converts licensing job task reference values to a display-safe scalar.
 * API may return plain ids or objects like { licensingJobId, catalogId } or
 * { licensingJobId, dealId }.
 * @param {unknown} value
 * @returns {string}
 */
export function formatJobTaskReferenceValue(value) {
  if (value == null || value === "") {
    return "";
  }

  if (typeof value === "object") {
    if (Array.isArray(value) || value instanceof Date) {
      return "";
    }

    const jobId = value.licensingJobId;
    const secondaries = SECONDARY_REFERENCE_KEYS
      .map((key) => value[key])
      .filter((id) => id != null)
      .map(String);

    if (jobId != null && secondaries.length > 0) {
      return [String(jobId), ...secondaries].join(" / ");
    }
    if (jobId != null) {
      return String(jobId);
    }
    if (secondaries.length > 0) {
      return secondaries.join(" / ");
    }
    return "";
  }

  return String(value);
}
